import { Typography } from '@mui/material';
import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

@autobind
export default class CampaignForm extends Component {
    static propTypes = {
        title: PropTypes.string,
        error: PropTypes.bool,
    };

    render() {
        return (
            <div className={classNames(styles.root, this.props.error && styles.error)}>
                <Title className={classNames(styles.title, this.props.error && styles.errorTitle)} size='md'>
                    <Typography sx={{ color: (t) => t.palette.primary.main }}>{this.props.title}</Typography>
                </Title>
                {this.props.children}
            </div>
        );
    }
}
